import api from '@api'

export function getMspApi() {
  return api.get('/mspconfiguration')
}
